import {Col, Row} from "antd";
import React, {useEffect, useState} from "react";
import {DateRangeFilter, SearchText} from "../../_defaultComponents/FilterComponents";
import UndeliveredShipmentsTable from "./undeliveredShipmentsTable/UndeliveredShipmentsTable";
import {useFetch} from "../../../hooks/useFetch";
import {useStore} from "../../../hooks/useStore";
import moment from "moment";

const UndeliveredShipments = () => {
    const [shipmentNumber, setShipmentNumber] = useState("");
    const defaultDateRange = [moment().subtract(30, "days"), moment()];
    const [dateRange, setDateRange] = useState(defaultDateRange);
    const [page, setPage] = useState(1);
    const stores = useStore();

    const [undeliveredShipmentsLoading, undeliveredShipments, , , refetch] = useFetch({
        fetchFn: () =>
            stores.transferStore.undeliveredShipments({
                shipmentNumber: shipmentNumber || undefined,
                startDate:
                    dateRange && dateRange?.length > 0
                        ? moment(dateRange[0]).format("YYYY-MM-DD")
                        : undefined,
                endDate:
                    dateRange && dateRange?.length > 0
                        ? moment(dateRange[1]).format("YYYY-MM-DD")
                        : undefined,
                page: page,
                limit: 10
            }),
        dependencies: [shipmentNumber, dateRange, page]
    });

    return (
        <div>
            <h2>İade Talepleri</h2>
            <Row gutter={[16, 16]} style={{marginBottom: "12px", display: "flex", gap: "12px"}}>
                <Col xs={24} sm={24} md={12} lg={5} xl={4}>
                    <SearchText
                        style={{width: "200px"}}
                        label="Paket Numarası"
                        value={shipmentNumber}
                        onChange={setShipmentNumber}
                    />
                </Col>
                <Col xs={24} sm={24} md={12} lg={6} xl={6}>
                    <DateRangeFilter
                        style={{width: "200px"}}
                        label="Tarih Aralığı"
                        onChange={value => setDateRange(value)}
                        value={dateRange}
                    />
                </Col>
            </Row>
            <div>
                <UndeliveredShipmentsTable
                    undeliveredShipments={undeliveredShipments}
                    undeliveredShipmentsLoading={undeliveredShipmentsLoading}
                    refetch={refetch}
                    page={page}
                    setPage={setPage}
                />
            </div>
        </div>
    );
};

export default UndeliveredShipments;
